// Resolved values of the blackdice.css theme tokens, for libraries (apexcharts,
// react-gauge-component) that need concrete colours rather than CSS custom properties.
// Keep in sync with .bd[data-theme] in blackdice.css.
import type { BDTheme } from './types';

export type ChartTokens = {
  accent: string;
  danger: string;
  warn: string;
  track: string;
  text: string;
  text2: string;
  mute: string;
  border: string;
};

export const chartTokens: Record<BDTheme, ChartTokens> = {
  dark: {
    accent: '#3BB586', danger: '#ff6b6b', warn: '#ffb56b', track: 'rgba(255,255,255,0.10)',
    text: '#e8f4f3', text2: '#b9cdd1', mute: '#8aa5ab', border: 'rgba(255,255,255,0.09)',
  },
  light: {
    accent: '#1d8e63', danger: '#d83a3a', warn: '#d97706', track: '#eef3f2',
    text: '#022a35', text2: '#2c4954', mute: '#5e7479', border: 'rgba(1,59,73,0.10)',
  },
};
